<template>
  <div>
    <el-dialog
      :visible="!!editingConsiderRow"
      title="掌门到期"
      width="1000px"
      @close="closeDialog"
    >
      <el-form :model="detail" ref="form" :rules="rules" label-width="130px">
        <el-form-item label="掌门价格">
          <el-input-number
            v-model="detail.ownerPrice"
            placeholder="FBS"
          ></el-input-number>
        </el-form-item>

        <el-form-item label="掌门到期时间">
          <el-date-picker
            v-model="detail.nextOwnerEndTime"
            value-format="timestamp"
            type="datetime"
            placeholder="续费截止时间"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSave()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';

export default {
  name: 'leagueDetail',
  props: ['editingConsiderRow'],
  data() {
    return {
      dialogVisible: false,
      detail: {},
      rules: {
        ownerPrice: {
          required: true,
          message: '请填写'
        },
        nextOwnerEndTime: [
          {
            required: true,
            message: '请填写'
          }
        ]
      }
    };
  },
  watch: {
    editingConsiderRow(val) {
      this.detail = (val && { ...val }) || {};
    }
  },
  methods: {
    ...mapActions('league', ['setConsider']),
    closeDialog() {
      this.$emit('close');
    },

    handleSave() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.doSave();
        }
      });
    },
    doSave() {
      this.setConsider({ ...this.detail, leagueId: this.detail.id }).then(
        () => {
          this.$message({
            message: '设置成功！',
            type: 'success'
          });
          this.closeDialog();
          this.$emit('refresh');
        }
      );
    }
  }
};
</script>

<style lang="less">
.editor {
  height: 500px;
}
</style>
